module.exports = __webpack_public_path__ + "img/site.65baf0ad.svg";